/**
 * Fetch Task Templates API
 * Feature: Generic Configurable Task System
 * Branch: 022-i-like-all
 */

import axiosInstance from '@/api/axiosInstance';
import { TaskTemplateFilters, TaskTemplatesListResponse } from './types';

export async function fetchTaskTemplates(
  filters: TaskTemplateFilters = {}
): Promise<TaskTemplatesListResponse> {
  const params = new URLSearchParams();

  if (filters.type) {
    params.append('type', filters.type);
  }
  if (filters.isActive !== undefined) {
    params.append('isActive', String(filters.isActive));
  }
  if (filters.search) {
    params.append('search', filters.search);
  }
  if (filters.createdBy) {
    params.append('createdBy', filters.createdBy);
  }

  const response = await axiosInstance.get<TaskTemplatesListResponse | TaskTemplatesListResponse['templates']>(
    '/api/task-templates',
    { params }
  );

  // Ensure we always return TaskTemplatesListResponse format
  if (Array.isArray(response.data)) {
    return {
      templates: response.data,
      totalCount: response.data.length
    };
  }

  return response.data as TaskTemplatesListResponse;
}